import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const locationBanners = document.querySelectorAll(".location-banner");
locationBanners.forEach((banner) => {
  const grid = banner.querySelector(".grid");
  const gridItemsLeft = banner.querySelectorAll(".grid > div:nth-child(odd)");
  const gridItemsRight = banner.querySelectorAll(".grid > div:nth-child(even)");

  console.log(gridItemsLeft, gridItemsRight);

  // gsap.to(gridItemsLeft, {
  //     y: '-98px',
  //     duration: 1,
  //     ease: 'power2.inOut',
  //     scrollTrigger: {
  //         trigger: banner,
  //         start: 'top 50%',
  //         end: 'bottom 50%',
  //         scrub: 2,
  //     },
  // });

  gsap.to(grid, {
    y: "-98px",
    duration: 1,
    ease: "power2.inOut",
    scrollTrigger: {
      trigger: banner,
      start: "top 50%",
      end: "bottom 50%",
      scrub: 2,
    },
  });

  if (grid && grid.querySelector(".second-image")) {
    gsap.to(gridItemsRight, {
      y: "-105%",
      duration: 1,
      ease: "power2.inOut",
      scrollTrigger: {
        trigger: banner,
        start: "top 50%",
        end: "bottom 50%",
        scrub: 2,
      },
    });
  }
});
